import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import Button from "components/Button";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  rechargeWallet,
  walletRechargeRetrive,
} from "redux/asyncApi/paymentApi";
import { numberRegexp } from "util/helpers";
import { cardValidator } from "./stripeMethods";
import StripeCardForm from "./StripeCardForm";
import { message } from "util/message";
import { validationMsg } from "util/validationErrors";

const WalletPaymentCard = ({
  handleClose,
  amount,
  setFormErrors,
  amountRef,
  formErrors,
}) => {
  const [paymentError, setPaymentError] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isPayButtonDisabled, setIsPayButtonDisabled] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [wallet_id, setWalletId] = useState(null);
  const {
    userAuth: { token },
  } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (amount === "") {
      setIsPayButtonDisabled(false);
      setFormErrors((prev) => {
        return {
          ...prev,
          amount: validationMsg.reqAmount,
        };
      });
      amountRef?.current?.focus();
    } else if (!numberRegexp.test(amount) || amount <= 0) {
      setFormErrors((prev) => {
        return {
          ...prev,
          amount: validationMsg.validAmount,
        };
      });
      amountRef?.current?.focus();
    } else {
      setIsPayButtonDisabled(true);
      rechargeWalletHandler();
    }
  };

  const rechargeWalletHandler = async () => {
    if (!stripe || !elements) {
      return;
    } else {
      const cardElement = elements.getElement(CardNumberElement);
      const cardExpiry = elements.getElement(CardExpiryElement);
      const cardCvc = elements.getElement(CardCvcElement);

      try {
        const stripeToken = await stripe.createToken(cardElement);
        const isNumberEmpty = cardElement._empty;
        const isNumberInvalid = cardElement._invalid;
        const isExpiryEmpty = cardExpiry._empty;
        const isExpiryInvalid = cardExpiry._invalid;
        const isCvcEmpty = cardCvc._empty;
        const isCvcInvalid = cardCvc._invalid;


        const errors = cardValidator(
          isNumberEmpty,
          isNumberInvalid,
          isExpiryEmpty,
          isExpiryInvalid,
          isCvcEmpty,
          isCvcInvalid
        );
        if (!errors) {
          setFormErrors({});
          setPaymentError();
          const values = {
            amount: amount,
            currency: "usd",
            recharge_type: "new_card",
            stripe_token: stripeToken.token.id,
          };
          dispatch(rechargeWallet({ token, values })).then(
            async ({ payload }) => {
              setWalletId(payload.wallet_details.id);
              if (
                payload.response?.status === "requires_action" &&
                payload.response.next_action.type === "use_stripe_sdk"
              ) {
                const { paymentIntent, error } =
                  await stripe.confirmCardPayment(
                    payload.response.client_secret
                  );
                const values = {
                  payment_status: paymentIntent?.status,
                  paymentintent_id: paymentIntent?.id,
                };
                if (!error) {
                  switch (paymentIntent.status) {
                    case "succeeded":
                      dispatch(walletRechargeRetrive({ token, values })).then(
                        ({ payload }) => {
                          if (payload.status) {
                            handleClose();
                            toast.success("Payment done Successfully");
                          }
                        }
                      );
                      break;
                    case "processing":
                      toast.info(message.paymentUnderProccess);
                      dispatch(walletRechargeRetrive({ token, values }));
                      break;
                    case "requires_payment_method":
                      toast.error(
                        message.paymentRejected
                      );
                      dispatch(walletRechargeRetrive({ token, values }));
                      break;
                    default:
                      toast.error(message.somethingWentWrong);
                      break;
                  }
                } else {
                  toast.error(message.paymentfailed);
                }
              } else {
                if (payload.status) {
                  console.log('');
                  toast.success(payload.message);
                  setPaymentSuccess(true);
                  setPaymentError(null);
                } else {
                  setPaymentError(payload.message);
                  setPaymentSuccess(false);
                }
              }
            }
          );
        } else {
          setIsPayButtonDisabled(false);
          setFormErrors(() => {
            return {
              ...errors,
            };
          });
          setPaymentError(
            message.anErrorOccured
          );
          const errorsEle = document.getElementById("errors_container");
          errorsEle?.focus();
        }
      } catch (error) {
        setPaymentError(message.anErrorOccured);
        setPaymentSuccess(false);
      }
    }
  };

  const onCancelButtonClick = () => {
    setTimeout(() => {
      let btn1 = document.getElementById("add_credit_to_wallet");
      if (btn1) {
        btn1.focus();
      }
    }, 1000);
  };

  return (
    <form onSubmit={onSubmitHandler} className="payment_form">
      <div>
        <StripeCardForm
          iconCols="col-sm-12"
          cardCols="col-sm-12"
          expiryCols="col-sm-6"
          cvcCols="col-sm-6"
          formErrors={formErrors}
          paymentError={paymentError}
          paymentSuccess={paymentSuccess}
          amount={amount}
          wallet_id={wallet_id}
        />
      </div>

      <div className="form-buttons flex items-center justify-end pt-4">
        <Button
          title={"Cancel"}
          className={"button--border me-2"}
          onClick={() => {
            handleClose();
            onCancelButtonClick();
          }}
        />
        <Button
          title={"Pay"}
          className={"button--blue"}
          type="submit"
          disabled={isPayButtonDisabled || !stripe}
        />
      </div>
    </form>
  );
};

export default WalletPaymentCard;
